const Actions = {
    SET_POPUP: "SET_POPUP",
 
  };
  
  export default Actions;
  